import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Languages } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LanguageSwitchProps {
  collapsed?: boolean;
  variant?: 'sidebar' | 'topbar';
  className?: string;
}

export const LanguageSwitch = ({ collapsed = false, variant = 'sidebar', className }: LanguageSwitchProps) => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
    localStorage.setItem('autoservice_language', newLang);
  };

  const currentLabel = i18n.language === 'en' ? 'English' : 'العربية';
  const targetLabel = i18n.language === 'en' ? 'العربية' : 'English';

  return (
    <Button
      variant={variant === 'topbar' ? 'secondary' : 'outline'}
      size={collapsed ? 'icon' : 'sm'}
      onClick={toggleLanguage}
      className={cn("gap-2 font-semibold", className)}
      title={`Switch to ${targetLabel}`}
    >
      <Languages className="h-4 w-4" />
      {!collapsed && <span>{currentLabel}</span>}
    </Button>
  );
};
